var Enum = Enum || {};

Enum.MEDICAL_TYPE = {
	CLINIC:				'CLINIC',
	PRIVATE_PRACTICE: 	'PRIVATE_PRACTICE'
};

Object.freeze(Enum.MEDICAL_TYPE);
